<template>
  <div>
    <Modal :modalId="modalId" size="modal-lg">
      <ModalHeader
        :title="$t('xPendingCancelInProgress')"
        icon="far fa-exclamation-triangle"
        :style="{ padding: '10px 10px 10px 10px' }"
      >
        <div class="cols-auto">
          <button type="button" class="btn btn-icon-button btn-icon-button--gray" @click="handleCloseClick()">
            <i class="fas fa-times" />
          </button>
        </div>
      </ModalHeader>
      <ModalBody>
        <div class="row">
          <div class="col">
            {{
              $t('xPendingCancelExplanationText', { cancelDate: $moment(planCanceledDate).format($t('xShortDate')) })
            }}
          </div>
        </div>
        <div class="row mt-4 mb-3">
          <div class="col">
            {{
              $t('xPendingCancelContactSupportText', { cancelDate: $moment(planCanceledDate).format($t('xShortDate')) })
            }}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button type="button" @click="handleCloseClick()" class="btn btn-secondary mr-2">
          {{ $t('xDone') }}
        </button>
        <button type="button" @click="navigateToPendingContactSupportPage()" class="btn btn-primary">
          {{ $t('xContactSupportUpgrade') }}
        </button>
      </ModalFooter>
    </Modal>
  </div>
</template>

<script>
/**
 * The PendingPlanCancelModal shows on the SubscriptionSettings details page, dashboard cards, and enrollment flows when there is a pending cancel
 * with the user's subscription and they try to update/upgrade their subscription. This modal prevents them from doing the actions that were previously listed.
 */
export default {
  props: ['modalId', 'planCanceledDate'],
  methods: {
    navigateToPendingContactSupportPage() {
      this.$appInsights.trackEvent({
        name: 'click-to-support-page-with-pending-cancel-subscription',
        properties: {}
      })
      this.closePendingPlanCancelModal()
      this.$router.push({
        path: `/support`
      })
    },

    handleCloseClick() {
      this.$appInsights.trackEvent({
        name: 'click-close-pending-cancel-subscription-modal',
        properties: {}
      })
      this.closePendingPlanCancelModal()
    },

    closePendingPlanCancelModal() {
      this.closeModal(this.modalId)
    }
  }
}
</script>
